import Directory from "../../components/directory/directory.component";

const Home = () => {
  const categories = [];
  return (
    <div>
      <Directory />
    </div>
  );
};

export default Home;
